import SearchBar from "../../ui/searchBar/searchBar";
import { Modal } from "react-bootstrap";
import "./Modal.css";

const ContainerModal = ({
  showModal,
  handleCloseModal,
  setData,
  url,
  fields,
  busqueda,
  setBusqueda,
  initial,
  perfiles,
  dataOriginal,
  isOn,
  setIsOn,
  width,
  height,
  setFilteredBase,
  specialties,
}) => {
  return (
    <Modal
      className="modal-container"
      show={showModal}
      onHide={handleCloseModal}
    >
      <Modal.Body>
        <SearchBar
          setData={setData}
          url={url}
          fields={fields}
          handleCloseModal={handleCloseModal}
          busqueda={busqueda}
          setBusqueda={setBusqueda}
          initial={initial}
          perfiles={perfiles}
          dataOriginal={dataOriginal}
          isOn={isOn}
          setIsOn={setIsOn}
          width={width}
          height={height}
          setFilteredBase={setFilteredBase}
          specialties={specialties}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ContainerModal;
